<template>
    <modal @close="$emit('close')" :show-title="true">
        <div slot="header">
            <h5 class="modal-title">{{$t('attenzione_label').toUpperCase()}}</h5>
        </div>
        <div slot="body">
            <div>
                {{this.$tc('removed_add_alert_1', this.adds.length)}}
            </div>
            <div>
                <b v-for="free_pick in this.adds">
                    {{free_pick}} <br>
                </b>
            </div>
            <div>
                {{this.$tc('removed_add_free_pick_alert_2', this.adds.length)}}
            </div>
        </div>
    </modal>
</template>

<script>
    import Modal from '../../partials/Modal';

    export default {
        name: "ModalRemovedAdds",
        components: {Modal},
        props: ['adds']
    }
</script>

<style scoped>

</style>
